import React, { useEffect, useRef, useState } from 'react';
import { useTable } from "./Table";
import { Dropdown, DropdownMenu, DropdownOption, DropdownTrigger } from '../ui/Dropdown';
import { createPortal } from 'react-dom';
import Input from '../ui/Input';
import Button from '../ui/Button';


const EditModal = ({ defaultValue, close, onEdit, offsetContainer }) => {
    const [editValue, setEditValue] = useState(defaultValue);
    const modal = useRef();
    
    const { status } = useTable();
    const handleSubmit = async (e) => {
      e.preventDefault();
      await onEdit(editValue);
      // After submitting, check if status.edit is "idle" and then call close()
      if (status.edit === "idle") {
        close();
      }
    };
  
    useEffect(() => {
      const { top, left } = offsetContainer.getBoundingClientRect();
  
      const modalWidth = modal.current.getBoundingClientRect().width;
  
      if (left < modalWidth) modal.current.style.translate = "30px 0px";
      else modal.current.style.translate = "calc(-100% - 4px) 0px";
  
      modal.current.style.top = `${window.scrollY + top}px`;
      modal.current.style.left = `${left}px`;
    }, []);
  
    return createPortal(
      <>
        <div onClick={close} className="fixed inset-0 z-50"></div>
  
        <div
          ref={modal}
          className="absolute bg-white border px-3 pb-3 flex flex-col items-end z-50"
        >
          <div className="h-[52px] flex items-center w-full justify-between">
            <h6 className="text-xl font-semibold">Edit Cell</h6>
  
            <button
              onClick={close}
              className="border size-8 flex justify-center items-center rounded-md"
            >
              <img src="/cross.svg" alt="close" className="size-4" />
            </button>
          </div>
  
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <Input
              value={editValue}
              onChange={
                (e) => {
                    setEditValue(e.target.value)
                }
              }
              placeholder="Enter value here"
              className="!h-11"
            />
  
            <div className="flex gap-2 self-end">
              <Button
                type="button"
                onClick={close}
                className="bg-transparent !text-cherry"
              >
                Cancel
              </Button>
  
              <Button
                type="submit"
                state={status.edit}
                disabled={
                  (editValue === "") ||
                  editValue === defaultValue ||
                  status.edit === "loading" 
                }
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </>,
      document.querySelector("#root")
    );
  };
const ContactCard = ({
    isChecked = false,
    fields = [],
    isLastValue = false,
    onViewDetails = () => { },
    onCheckboxChange = () => { },
    rowDetail,
    filteredOptions,
    handleClick,
    idx,
    customComponents = {} // Use this to pass custom components including buttons
}) => {
    const { selectedRows,onEdit } = useTable();
    const dropdownRef = useRef(null);
    const firstName = fields.find(field => field.key === 'firstName')?.value || '';
    const id = fields.find(field => field.key === 'id')?.value || '';
    const editBtn = useRef();
    const [isEditing, setIsEditing] = useState(false);


    const handleCheckboxChange = () => {
        onCheckboxChange({id:id});
    };

    // Helper function to render custom field
    const renderCustomField = (field, index, isLast) => {
        const borderClass = isLast ? '' : 'border-b border-[#EAEDF2]';
        if (field.key === 'firstName') return null;
        if (field.key === 'id') return null;

        // Check if there's a custom component for this field
        if (customComponents[field.key]) {
            const specialRender = customComponents[field.key];
    
            if (specialRender && typeof specialRender === 'function') {
                return specialRender(field.value,rowDetail);
            }
            
            return <span className="font-medium">{field.value}</span>;
        }

        if (field.type === 'phone') {
            const str = field?.value ? field.value?.toString()?.replace(/\D/g, '') : field?.value || null;
            return (
                <div key={index} className={`flex justify-between xxs:p-[9.5px] p-[8px] items-center ${borderClass}`}>
                    <span className="text-[16px] font-medium leading-[26px] tracking-normal font-mont">{field.label}</span>
                    <div className="flex items-center flex-wrap">
                    {
                        str ? 
                        <a href={`tel:+1${str}`} className="text-black mr-[20px] flex flex-wrap">
                            <span className='flex text-[16px] font-normal leading-[26px] tracking-normal font-mont text-lightBlack'>
                                <span className='underline whitespace-nowrap'>
                                    {str ? str?.slice(0, 3) + "-" + str?.slice(3, 6) + "-" + str?.slice(6) : 'missing'}
                                </span>
                                <img src="/edit.svg" alt="" className="size-[18px] mt-1 ml-1 cursor-pointer" ref={editBtn}
                                    onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setIsEditing((prev) => !prev);
                                    }}
                                />
                                <img src='/phone.svg' alt='phone' className='ml-[20px] h-[22px] w-[22px]' />
                            </span>
                        </a> : <span className="text-black">
                            <span className='flex text-[16px] font-normal leading-[26px] tracking-normal font-mont text-lightBlack'>
                                <span className='flex'>
                                    {str ? str?.slice(0, 3) + "-" + str?.slice(3, 6) + "-" + str?.slice(6) : 'missing'}
                                    <img src="/edit.svg" alt="" className="size-[18px] mt-1 ml-1 cursor-pointer" ref={editBtn} 
                                          onClick={e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setIsEditing((prev) => !prev);
                                        }}
                                    />
                                </span>
                            </span>
                        </span> 
                    }
                    {
                        str ? 
                        <a href={`sms:+1${str}`} className="text-black">
                            <img src='/icons8-chat-bubble-30.svg' height={22} width={22} alt='email' />
                        </a> : null
                    }
                    {isEditing && (
                        <EditModal
                        defaultValue={field?.value}
                        close={() => setIsEditing(false)}
                        onEdit={(value) => onEdit(rowDetail, {key:'phone_number'}, value)}
                        offsetContainer={editBtn.current}
                    />
                    )}
                    </div>
                </div>
            );
        } else if(field.type === 'action') {
            const handleClickList = (listName, rowDetail) => {
                handleClick(listName, rowDetail);
                if (dropdownRef.current) {
                  dropdownRef.current.click();
                }
            };
            return (
                <div ref={dropdownRef} className="p-[9.5px] items-center border-b border-[#EAEDF2]">
                    <Dropdown>
                        <DropdownTrigger className="text-[16px] font-medium leading-[26px] tracking-normal font-mont text-white bg-customRed p-[7px] rounded-[5px] uppercase">{field?.value}</DropdownTrigger>
                        <DropdownMenu  className="w-full mt-1 bg-white border rounded-md shadow-lg overflow-auto">
                            {filteredOptions.map((listName, index) => (
                                <DropdownOption
                                    key={index}
                                    onClick={() => handleClickList(listName,rowDetail)}
                                    className={`capitalize px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer li_${index}_${typeof listName === 'object' ? listName.name || listName.label || listName.toString() : listName}`}
                                >
                                    {typeof listName === 'object' ? listName.name || listName.label || listName.toString() : listName}
                                </DropdownOption>
                            ))}
                            
                            {filteredOptions.length === 0 && (
                                <div className="px-3 py-2 text-sm text-gray-500 italic">
                                    No options available
                                </div>
                            )}
                        </DropdownMenu>
                    </Dropdown>
                </div>
            );

        } else if (field.custom) {
            return (
                <div key={index} className={`p-[10px] ${borderClass}`}>
                    {field.custom}
                </div>
            );
        } else {
            return (
                <div key={index} className={`flex justify-between xxs:p-[9.5px] p-[8px] items-center ${borderClass}`}>
                    <span className="text-[16px] font-medium leading-[26px] tracking-normal font-mont">{field.label}</span>
                    <span className="text-[16px] font-normal leading-[26px] tracking-normal font-mont text-lightBlack truncate max-w-[180px]" title={field.value == 0 ? 0 : field.value || '-'}>{field.value == 0 ? 0 : field.value || '-'}</span>
                </div>
            );
        }
    };

    return (
        <div className={`border border-[#EAEDF2] w-full ${isLastValue ? '' : 'mb-[10px]'}`}>
            <div className="xs:flex xs:justify-between xs:items-center bg-[#e5e7eb] p-2">
                <div className="flex items-center mt-[3px] gap-[10px]">
                {
                    isChecked ?
                        <input
                            type="checkbox"
                            checked={selectedRows?.includes(id)}
                            onChange={handleCheckboxChange}
                            className="checkbox checkbox-white checkbox-responsive"
                        />
                    : null
                }
                    <span className="text-[20px] font-medium leading-[26px] tracking-normal font-mont truncate max-w-[300px] capitalize" title={firstName}>{firstName}</span>
                </div>
                <button
                    onClick={onViewDetails}
                    className="text-[16px] font-medium leading-[26px] tracking-normal font-mont text-[#D30039] block xs:ml-0 ml-auto xs:mt-0 mt-[5px]"
                >
                    View Details
                </button>
            </div>

            <div>
                {fields.map((field, index) =>
                    renderCustomField(field, index, index === fields.length - 1)
                )}
            </div>
        </div>
    );
};

export default ContactCard;